<template>
  <div class="footLayout">
    <div class="foot">
      <div class="footText0">
        <router-link to="/About" class="logoA">
          <div class="logoText">北斗院</div>
        </router-link>
      </div>
      <div class="footText1">
        <span class="vLine"></span>
      </div>
      <div class="footText2">
        <img class="logoBig" src="../../static/images/logoBig.png" />
      </div>
      <div class="footText3">
        <div class="textItem0Foot">商务合作</div>
        <div class="textItemFoot1">info@szbit.cn</div>
      </div>
         <div class="footText">
        <div class="textItem0Foot">关于我们</div>
         <div class="textItemFoot" @click="goTarget('/About')">公司介绍</div>
         <div class="textItemFoot" @click="goTarget('/About')">发展历程</div>
         <div class="textItemFoot" @click="goTarget('/News')">新闻中心</div>
      </div>

      <div class="footText">
        <div class="textItem0Foot">加入我们</div>
         <div class="textItemFoot" @click="goTarget('/join')">人才招聘</div>
      </div>
      <div class="footText">
        <div class="textItem0Foot">关注我们</div>
        <div>
          <img src="../../static/images/vendor.png" />
        </div>
      </div>
    </div>
    <div class="copy-right">
      <!-- <div class="line"></div> -->
      <div class="right">Copyright©2020-2030深圳北斗应用技术研究院有限公司,保留所有权利  <span style="cursor: pointer;" @click="toGov">{{ copyright }}</span></div>
    </div>
  </div>
</template>


<script>
export default {
  name: "WiseBrain",
  inject:["reload"],
  data() {
    return {
      copyright: '粤ICP备15028556号-2'
    };
  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      if(this.$route.params.touid){//判断id是否有值
      this.reload();
      }
    }
  },
  mounted() {
    if(window.location.host === 'openxdata.cn'){
      this.copyright = '粤ICP备15028556号-1';
    }else{
      this.copyright = '粤ICP备15028556号-2';
    }
  },
  methods: {
    toGov(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index');
    },
    goTarget(index) {
            // console.log(this.$route.path)
      //判断是否是刷新当前页面
            if(this.$route.path.indexOf(index)!= -1){
                  let id = Math.ceil(Math.random()*1000000); 
              this.$router.push('/About?id='+id);
              this.reload();
            }
            else{
                this.$router.push({
                    path: index,
                  });
            }
    },
  },
};
</script>
<style scoped>
@import "./Foot.css";
</style>



// WEBPACK FOOTER //
// src/views/Foot.vue